import React, { useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import MaterialTable, { MTableToolbar } from 'material-table';
import generateNotifications from 'helpers/NotificationsCenter';

import {
  CardContent,
  Grid,
  Button,
  TextField,
} from '@material-ui/core';

import { useStyles } from '../../styles';

import { UserData } from 'services/dataService';
import { localizationTable, options, optionsNoPagination} from 'constants/table';
import { Search } from '@material-ui/icons';
import GamificationData from 'services/dataService/GamificationData';
import { useSelector } from 'react-redux';

export default () => {
  // const [name, setName] = useState('');
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [filter, setFilter] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [qtdPoints, setQtdPoints] = useState(0);
  const [observations, setObservations] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState(null);
  const [transactions, setTransactions] = useState([]);

  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
  ]);
  const { register, handleSubmit, control } = useForm();
  const tableRef = useRef();
  const classes = useStyles();

  const { id_company, id, name, idStudentUser, email } = useSelector((state) => state.auth);
  const [coinName, setCoinName] = useState();

  useEffect(() => {
    getGamification();
  }, []);

  function formatarDataIntl(isoString) {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).format(new Date(isoString));
  }

  const handleSetUserId = (id) => {
    setSelectedUserId(id);
  };

  async function getAllTransactions(id) {
    const transactionsResponse = await GamificationData.getAllTransactions({ "id_user": id });
    const { data } = transactionsResponse;
    setTransactions(data);
  }

  async function getGamification(id) {
    const gamificationData = await GamificationData.getGamificationByIdCompany({ "id_company": id_company });
    const { data } = gamificationData;
    data.map((gamification, index) => {
      setCoinName(gamification.coin_name);
    })
  }

  async function handleSubmitForm(event, data) {
    event.preventDefault();

    const gamificationTransactionResponse = await GamificationData.createTransaction({
      amount: qtdPoints,
      type: data.type,
      observations: observations,
      id_user: data.id_user,
      id_admin: id
    })

    if (gamificationTransactionResponse.status === 200 && gamificationTransactionResponse.data.data.message === "Success") {
      setIsModalOpen(!isModalOpen);
      setFeedbackMessage("Transação processada com sucesso");

      await generateNotifications("pointsEarned", {
        name: name,
        qtdPoints: qtdPoints,
        coinName: coinName,
        user: selectedUserId,
        company: id_company,
        read: false,
        transactionType: gamificationTransactionResponse.data.transaction.type,
        email: email,
      });

      setTimeout(() => {
        setFeedbackMessage(null);
        window.location.reload();
      }, 2000)
    }
  }

  const handleSubmitFilter = (data) => {
    setFilter(data.filter);

    tableRef.current.state.query.page = 0;
    tableRef.current.onQueryChange();
  };

  return (
    <div className='notranslate'>
      {
        feedbackMessage && (
          <div className={classes.modal}>
            <div className={classes.feedbackMessageContainer}>
              <p>{feedbackMessage}</p>
            </div>
          </div>
        )
      }
      {
        isModalOpen && (
          <>
            <div className={classes.modal}>
              {
                modalType === "add" && (
                  <div className={classes.modalContent}>
                    <div className={classes.modalHeader}>
                      <h1 className={classes.modalHeaderTitle}>Adicionar pontos</h1>
                      <div className={classes.modalClose}>
                        <a onClick={() => setIsModalOpen(!isModalOpen)}>
                          <span className={classes.modalCloseIcon}>✖</span>
                        </a>
                      </div>
                    </div>
                    <div className={classes.modalContainer}>
                      <form className={classes.modalForm} onSubmit={(event) => handleSubmitForm(event, { type: "CREDIT", id_user: selectedUserId })}>
                        <input type='number' onChange={(e) => setQtdPoints(e.target.value)} className={classes.modalFormInput} placeholder='Quantidade' />
                        <textarea type='text' onChange={(e) => setObservations(e.target.value)} className={classes.modalFormInput} placeholder='Observações' />
                        <button type='submit' className={classes.modalFormButton}>Adicionar</button>
                      </form>
                    </div>
                  </div>
                )
              }
              {
                modalType === "remove" && (
                  <div className={classes.modalContent}>
                    <div className={classes.modalHeader}>
                      <h1 className={classes.modalHeaderTitle}>Remover pontos</h1>
                      <div className={classes.modalClose}>
                        <a onClick={() => setIsModalOpen(!isModalOpen)}>
                          <span className={classes.modalCloseIcon}>✖</span>
                        </a>
                      </div>
                    </div>
                    <div className={classes.modalContainer}>
                      <form className={classes.modalForm} onSubmit={(event) => handleSubmitForm(event, { type: "DEBIT", id_user: selectedUserId })}>
                        <input type='text' onChange={(e) => setQtdPoints(e.target.value)} className={classes.modalFormInput} placeholder='Quantidade' />
                        <textarea type='text' onChange={(e) => setObservations(e.target.value)} className={classes.modalFormInput} placeholder='Observações' />
                        <button type='submit' className={classes.modalFormButton}>Remover</button>
                      </form>
                    </div>
                  </div>
                )
              }
              {
                modalType === "stats" && (
                  <div className={classes.modalStats}>
                    <div className={classes.modalStatsHeader}>
                      <div className={classes.modalStatsIntern}>
                        <h1 style={{ margin: 0, fontSize: "20px", fontWeight: "600" }}>Ver Extrato</h1>
                        <button
                          onClick={() => setIsModalOpen(false)}
                          className={classes.modalStatsClose}
                        >
                          ✖
                        </button>
                      </div>
                      <div style={{ flex: 1, overflowY: "auto", padding: "20px" }}>
                        {transactions && transactions.map((transaction, index) => (
                          <div
                            key={index}
                            className={classes.modalStatsPadding}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                              <div style={{    background: transaction.type === "CREDIT" ? "#d1fae5" : "#fee2e2"}} className={classes.modalStatsCredit}>
                                {transaction.type === "CREDIT" ? "➕" : "➖"}
                              </div>
                              <div>
                                <p style={{ margin: 0, fontWeight: "600", color: "#111" }}>
                                  {transaction.observations}
                                </p>
                                <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#666" }}>
                                  {formatarDataIntl(transaction.createdAt)}
                                </p>
                              </div>
                            </div>

                            <div style={{ textAlign: "right" }}>
                              <p className={classes.modalStatsColor} style={{color: transaction.type === "CREDIT" ? "green" : "red" }}>
                                {transaction.type === "CREDIT" ? "+" : "-"}{transaction.amount}
                              </p>
                              <span style={{ fontSize: "13px", color: "#777" }}>pontos</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          </>
        )
      }
      <MaterialTable
        title={`${t('Gestão de Pontos')}`}
        tableRef={tableRef}
        columns={[
          {
            title: `${t('Nome')}`,
            field: `name`,
            sorting: false,
            render: (rowData) => rowData.name,
          },
          {
            title: `${t('E-mail')}`,
            sorting: false,
            field: 'email',
            render: (rowData) => rowData.email,
          },
          {
            title: `${t('CPF')}`,
            field: 'cpf',
            sorting: false,
            render: (rowData) => rowData.cpf,
          },
          {
            title: `${t('Pontos')}`,
            field: 'total_coins',
            sorting: false,
            render: (rowData) => rowData.UserCoins?.[0]?.total_coins ?? 0
          },
        ]}
        data={async (query) => {
          try {
            const response = await GamificationData.getAllUserCoins({
              page: query.page + 1,
              limit: query.pageSize,
              filter,
            });

            setIsLoading(false);

            return {
              data: response.data.users,
              page: response.data.currentPage - 1,
              totalCount: response.data.totalCount,
            };
          } catch (err) {
            if (err.response?.status === 403) {
              toast.error(t('toastify:commons.toast_error_403'));
            } else {
              toast.error(t('toastify:commons.toast_error_api'));
            }
            setIsLoading(false);

            return { data: [] };
          }
        }}
        components={{
          search: true,
          title: false,
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <form onSubmit={handleSubmit(handleSubmitFilter)}>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={8} xs={12}>
                      <TextField
                        fullWidth
                        label={t('form:commons.input_search')}
                        name="filter"
                        type="text"
                        variant="outlined"
                        defaultValue={filter || ''}
                        inputRef={register}
                      />
                    </Grid>
                    <Grid item md={4} xs={12} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        type="submit"
                      >
                        <Search style={{ marginRight: '5px' }} />
                        {t('button:commons.btn_advanced_filter')}
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </form>
            </div>
          ),
        }}
        actions={[
          {
            icon: 'add',
            tooltip: `Adicionar`,
            position: 'row',
            onClick: (event, rowData) => {
              event.preventDefault();
              setIsModalOpen(!isModalOpen);
              setModalType("add");
              handleSetUserId(rowData.id);
            },
            iconProps: { color: 'primary' },
          },
          {
            icon: 'remove',
            tooltip: `Remover`,
            position: 'row',
            onClick: (event, rowData) => {
              event.preventDefault();
              setIsModalOpen(!isModalOpen);
              setModalType("remove");
              handleSetUserId(rowData.id);
            },
            iconProps: { color: 'primary' },
          },
          {
            icon: 'equalizer',
            tooltip: `Ver Extrato`,
            position: 'row',
            onClick: (event, rowData) => {
              event.preventDefault();
              setIsModalOpen(!isModalOpen);
              setModalType("stats");
              handleSetUserId(rowData.id);
              getAllTransactions(rowData.id);
            },
            iconProps: { color: 'primary' },
          },
        ]}
        isLoading={isLoading}
        localization={localizationTable(t)}
        options={{
          ...options,
          exportFileName: "Points",
          exportButton: true,
          exportCsv: () => {
            GamificationData.getAllUserCoins({ page: 1, limit: 999999, filter }).then((response) => {
              const data = response.data.users.map(user => ({
                Nome: user.name,
                Email: user.email,
                CPF: user.cpf,
                Pontos: user.UserCoins?.[0]?.total_coins ?? 0
              }));
        
              const csvRows = [];
              const headers = Object.keys(data[0]);
              csvRows.push(headers.join(','));
        
              for (const row of data) {
                csvRows.push(headers.map(h => `"${row[h]}"`).join(','));
              }
        
              const csvString = csvRows.join('\n');
              const blob = new Blob([csvString], { type: 'text/csv' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.setAttribute('hidden', '');
              a.setAttribute('href', url);
              a.setAttribute('download', 'Points.csv');
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            });
          }
        }}
      />
    </div>

  );
};
